/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import LoginForm from '~components/organisms/LoginForm/LoginForm';
import Loader from '~components/atoms/Loader/Loader';
import { getNewToken } from '~src/services/api/api-cweb';
import { notification } from 'antd';
import BackgroungImage from '~src/assets/c_web_projekt_bg_gray.jpg';
import Logo from '~src/assets/c-web-logo-white.png';
import DarkLogo from '~src/assets/c-web-logo-darkgray.png';
import { useIntl } from 'react-intl';
import ForgotPasswordForm from '~components/organisms/ForgotPasswordForm/ForgotPasswordForm';

type LoginMode = 'login' | 'forgot';

/** Login page */
const Login = () => {
  const style = useStyles(styleFn);
  const [api, contextHolder] = notification.useNotification();
  const intl = useIntl();

  const [mode, setMode] = useState<LoginMode>('login');

  const [doGetNewToken, getNewTokenMutation] = useMutation(getNewToken, {
    onError: () => {
      api.error({
        message: intl.formatMessage({ id: 'login-error' }),
      });
    },
    onSuccess: () => {
      window.location.pathname = '/';
    },
  });

  const onSubmit = (data) => doGetNewToken(data);

  const handleShowLogin = () => setMode('login');
  const handleShowForgot = () => setMode('forgot');

  return (
    <div css={style.wrapper}>
      {contextHolder}
      <div css={style.container}>
        <img src={Logo} alt="" css={style.logo} />
        <img src={DarkLogo} alt="" css={style.darkLogo} />

        {mode === 'login' && (
          <LoginForm
            onSubmit={onSubmit}
            isError={getNewTokenMutation.isError}
            onForgotPasswordClick={handleShowForgot}
          />
        )}

        {mode === 'forgot' && (
          <ForgotPasswordForm onBackToLogin={handleShowLogin} />
        )}
      </div>
      {getNewTokenMutation.isLoading && <Loader withBackgroundOverlay />}
    </div>
  );
};

export default Login;

const styleFn: ThemedStyleFn = () => ({
  wrapper: {
    width: '100%',
    height: '100vh',
    backgroundImage: `url(${BackgroungImage})`,
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    padding: '0 25px',
    width: '100%',
    height: '100%',
    maxWidth: '1200px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    '@media (max-width: 600px)': {
      justifyContent: 'center',
    },
  },
  logo: {
    src: Logo,
    width: '200px',
    marginTop: '100px',
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  darkLogo: {
    position: 'absolute',
    width: '200px',
    top: '30px',

    '@media (min-width: 601px)': {
      display: 'none',
    },
  },
});
